import React from "react";
import { ShieldAlert } from "lucide-react";
import { usePermission } from "../../hooks/usePermission";
import { EmptyState } from "./_shared";

/** Chặn truy cập trực tiếp bằng URL vào trang cần quyền (menu chỉ ẩn mục, không đủ để chặn). */
export default function RequirePerm({ perm, children }) {
  const { can, roleLabel } = usePermission();
  if (can(perm)) return children;
  return (
    <EmptyState
      icon={ShieldAlert}
      title="Bạn chưa có quyền truy cập trang này"
      description={`Vai trò hiện tại của bạn là "${roleLabel}". Hãy liên hệ chủ sở hữu hệ thống nếu cần được cấp quyền.`}
    />
  );
}
